import React from "react";
import { DAY_WIDTHS } from "../engine/timelineGeometry";
import { usePlannerEngine, useRowModel, useView, useViewport } from "../plannerContext";
import TimelineRow from "./TimelineRow";

/** The rows that are on screen (and a little beyond), each placed at its offset. */
function TimelineRows() {
  const { timeline } = usePlannerEngine();
  const model = useRowModel();
  const viewType = useView((state) => state.viewType);
  const enteringPrefix = useView((state) => state.enteringPrefix);
  const firstDay = useViewport((state) => state.firstDay);
  const lastDay = useViewport((state) => state.lastDay);
  const firstRow = useViewport((state) => state.firstRow);
  const lastRow = useViewport((state) => state.lastRow);

  const dayWidth = DAY_WIDTHS[viewType];
  const rows = [];

  for (let i = Math.max(0, firstRow); i <= lastRow && i < model.rows.length; i += 1) {
    const row = model.rows[i];
    rows.push(
      <TimelineRow
        key={row.key}
        row={row}
        top={model.tops[i]}
        firstDay={firstDay}
        lastDay={lastDay}
        originDay={timeline.originDay}
        dayWidth={dayWidth}
        entering={Boolean(enteringPrefix) && row.key.startsWith(`${enteringPrefix}/`)}
      />
    );
  }

  return <>{rows}</>;
}

export default React.memo(TimelineRows);
